import { useClockSettingsStore } from "@store/timeStore";
import React from "react";

export function ClockBackground() {
  return (
    <>
      {/* Dial face — light: #FAFAFA, dark: #1A1D24 (see iOS dialBackground line 543) */}
      <div
        id="clock-dial-face"
        className="mx-auto my-auto rounded-full absolute inset-[0%]"
        style={{ background: 'var(--clock-dial)' }}
      />
      {/* Conic time-of-day gradient — same stops in both modes per iOS dialGradient */}
      <div
        id="clock-gradient"
        className="mx-auto my-auto rounded-full absolute inset-[8%]"
        style={{ background: 'var(--clock-dial-gradient)' }}
      />
      <Crosshairs />
      <NumberLabels inset={1} />
    </>
  );
}

function Crosshairs() {
  // Both lines pass through dead center (50%/50%). The previous `mb-[2px]` /
  // `ml-[2px]` margins shifted each line ~1px off-axis, which compounded with
  // the gradient's stale `at 51.12% 48.95%` origin to produce a visible
  // misalignment. Gradient origin is now `at 50% 50%` in globals.css.
  return <>
    <div id="clock-crosshairs" className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <div className="w-full h-[2px]" style={{ background: 'var(--clock-crosshair)' }} />
    </div>
    <div id="clock-crosshairs" className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <div className="h-full w-[2px]" style={{ background: 'var(--clock-crosshair)' }} />
    </div>
  </>
}

export function NumberLabels({ inset }: { inset: number }) {
  const { timeFormat } = useClockSettingsStore();

  const labels12h = ["12p", "6p", "12a", "6a"];
  const labels24h = ["12", "18", "00", "06"];
  const labels = timeFormat.hour12 ? labels12h : labels24h;
  // Font scales with the dial via container-query units (the dial wrapper is a
  // `container-type: inline-size` container) so the labels always sit inside the
  // 8% white border ring instead of being a fixed 24px that dwarfs a phone dial.
  // The `-0.4em` nudges keep the top/bottom glyphs centered on the ring band.
  return (
    <div
      id="clock-number-labels"
      className="absolute flex items-center justify-center pointer-events-none text-muted-foreground"
      style={{ inset: `${inset}%`, fontSize: 'clamp(9px, 5cqw, 22px)', lineHeight: 1 }}
    >
      <span className="absolute top-0 font-rounded tabular-nums tracking-tight" style={{ marginTop: '-0.4em' }}>{labels[0]}</span>
      <span className="absolute right-0 font-rounded tabular-nums tracking-tight">{labels[1]}</span>
      <span className="absolute bottom-0 font-rounded tabular-nums tracking-tight" style={{ marginBottom: '-0.4em' }}>{labels[2]}</span>
      <span className="absolute left-0 font-rounded tabular-nums tracking-tight">{labels[3]}</span>
    </div>
  );
}
